import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18.8399 20.999H4.38086V14.599H5.98086V19.399H17.2399V14.599H18.8399V20.999ZM15.6399 17.799H7.58086V16.199H15.6359V17.799H15.6399ZM15.6399 15.799L7.78086 14.16L8.11886 12.608L15.9799 14.25L15.6369 15.799H15.6399ZM16.0789 13.762L8.79886 10.362V10.356L9.47286 8.89902L16.7539 12.299L16.0809 13.763L16.0789 13.762ZM17.0019 11.917L10.8319 6.77702H10.8409L11.8539 5.56302L18.0159 10.699L16.9989 11.918L17.0019 11.917ZM18.3099 10.417L13.5029 3.96802L14.8129 2.99902L19.6189 9.45002L18.3069 10.421L18.3099 10.417Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "StackOverflow"
);
